import angular from 'angular';
import { AccountLicenseFiltersController } from './account-license-filters.view/account-license-filters';
import { AccountSettingsController } from './account-settings.view/accountSettings';
import { AccountYourFontsController } from './account-your-fonts.view/account-your-fonts';
import tnDownloadEulaLink from './download-eula-link.directive/downloadInvoiceLink';
import { TnFontDownloadLinkComponentOptions } from './download-font-link.directive/downloadFontLink';
import tnDownloadFontButton from './download-font.directive/downloadFont';
import tnDownloadInvoiceLink from './download-invoice-link.directive/downloadInvoiceLink';
import { OrderDetails } from './orders-detail.view/ordersDetail';

export default angular
    .module('tn.account', [
        'tn.django',
        'tn.cart',
        'tn.fonts',
        'tn.utils',
        'tn.billing',
        'tn.licenses',
    ])
    .component('tnFontDownloadLink', TnFontDownloadLinkComponentOptions)
    .controller('tnAccountLicenseFilters', AccountLicenseFiltersController)
    .controller('tnAccountSettings', AccountSettingsController)
    .controller('tnAccountYourFonts', AccountYourFontsController)
    .controller('tnOrdersDetail', OrderDetails)

    .directive('tnDownloadEulaLink', tnDownloadEulaLink)
    .directive('tnDownloadFontButton', tnDownloadFontButton)
    .directive('tnDownloadInvoiceLink', tnDownloadInvoiceLink).name;
